import "/app/node_modules/core-js/modules/es.array.iterator.js";
import "/app/node_modules/core-js/modules/es.promise.js";
import "/app/node_modules/core-js/modules/es.object.assign.js";
import "/app/node_modules/core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import toasted from "vue-toasted";
import router from "./router";
import moment from "moment";
import { EventBus } from "@/js/events/bus.js";
import BootstrapVue from "bootstrap-vue";
import * as VueGoogleMaps from "vue2-google-maps";
import Router from "vue-router";
import VueLazyload from "vue-lazyload";
import "./js/prototype";
import ProductZoomer from "vue-product-zoomer";
import { initStoredCurrencies } from "@/js/currency/currencies";
import MaintenanceMode from "./plugins/maintenanceMode";
import AOS from "aos";
import "aos/dist/aos.css";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDuCcTewU7bypWjqn9lMelhI3vZLBFbh-Y",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
});
var toastedOptions = {
  theme: "toasted-primary",
  action: {
    text: "Close",
    onClick: function onClick(e, toastObject) {
      toastObject.goAway(0);
    }
  },
  position: "bottom-right",
  fullWidth: false,
  duration: 5000
};
Vue.use(ProductZoomer);
Vue.use(Router);
Vue.use(toasted, toastedOptions);
Vue.use(BootstrapVue);
Vue.use(require("vue-shortkey"));
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
});
Vue.use(MaintenanceMode);
window.whitelabel = __WHITELABEL__;
Vue.prototype.$whitelabel = __WHITELABEL__;
Vue.prototype.$location = window.location;
Vue.prototype.$EventBus = EventBus;
Vue.config.productionTip = false;

//Date & Datetime format
Vue.filter("formatDateTime", function (value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY HH:mm"); //English display
  }
});
Vue.filter("formatDateTimeToLocal", function (value) {
  if (value) {
    return moment(String(value)).local().format("MM/DD/YYYY HH:mm");
  }
});
Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY"); //English display
  }
});
Vue.filter("formatDate_string", function (value) {
  if (value) {
    return moment(String(value)).format("DD MMMM YYYY"); //English display
  }
});
Vue.filter("formatDate_stringMonth", function (value) {
  if (value) {
    return moment(String(value)).format("MMMM YYYY"); //English display
  }
});
var paging = Vue.component("paging", {
  name: "paging",
  constructor: require("./components/paging/PagingComponent.vue").defaults
});

// This callback runs before every route change, including on page load.
router.beforeEach(function (to, from, next) {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  var nearestWithTitle = to.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.title;
  });

  // Find the nearest route element with meta tags.
  var nearestWithMeta = to.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.metaTags;
  });
  var previousNearestWithMeta = from.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.metaTags;
  });

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(function (el) {
    return el.parentNode.removeChild(el);
  });

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(function (tagDef) {
    var tag = document.createElement("meta");
    Object.keys(tagDef).forEach(function (key) {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute("data-vue-router-controlled", "");
    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(function (tag) {
    return document.head.appendChild(tag);
  });
  next();
});

/**
 * Content Security Policy (CSP) configurations for different
 * CSP is used to prevent various types of attacks, such as Cross Site Scripting (XSS)
 * and data injection attacks.
 */
/**
 * Object holding the CSP configurations for different environments.
 */
var cspConfig = {
  development: {
    "default-src": ["'self'"],
    "script-src": ["'self' data: blob: ", "'unsafe-inline'", "https://hcaptcha.com", "https://*.hcaptcha.com", "http://js.stripe.com",
    //dev
    "https://maps.googleapis.com", "http://checkout.stripe.com"],
    "img-src": ["'self' data: blob: ", "https://" + process.env.VUE_APP_STATIC_ASSETS_HOST, "https://s3.amazonaws.com/", "https://dfwa-prod-img.s3.amazonaws.com", "https://*.s3.amazonaws.com", "https://*.us-east-1.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.us-east-1.amazonaws.com", "https://www.googletagmanager.com", "https://*.stripe.com", "https://cdn.sanity.io"],
    "style-src": ["'self'", "'unsafe-inline'", "https://" + process.env.VUE_APP_STATIC_ASSETS_HOST, "https://*.s3.amazonaws.com", "https://*.us-east-1.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.us-east-1.amazonaws.com", "https://cdn.quilljs.com", "https://cdn.jsdelivr.net", "https://api.mapbox.com", "https://hcaptcha.com", "https://*.hcaptcha.com", "sha256-0hAheEzaMe6uXIKV4EehS9pu1am1lj/KnnzrOYqckXk=", "https://fonts.googleapis.com"],
    "font-src": ["'self'", "https://fonts.gstatic.com", "http://js.stripe.com", "https://fonts.googleapis.com", "https://*.s3.amazonaws.com", "https://*.us-east-1.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.us-east-1.amazonaws.com", "https://" + process.env.VUE_APP_STATIC_ASSETS_HOST],
    "connect-src": [process.env.VUE_APP_API_URL, process.env.VUE_APP_CAP_URL, "https://api.stripe.com", "*"],
    "frame-src": ["'self'", "http://js.stripe.com", "http://checkout.stripe.com", "http://hooks.stripe.com", "http://connect-js.stripe.com", "https://hcaptcha.com", "https://*.hcaptcha.com"],
    "worker-src": ["'self' blob:"],
    "media-src": ["'self'", "https://" + process.env.VUE_APP_STATIC_ASSETS_HOST, "https://*.s3.amazonaws.com", "https://*.us-east-1.s3.amazonaws.com", "https://candm-prod-webshop-static-assets.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.us-east-1.amazonaws.com"]
  },
  production: {
    "default-src": ["'self'"],
    "script-src": ["'self'", "'unsafe-inline'", "https://js.stripe.com", "https://maps.googleapis.com", "https://hcaptcha.com", "https://*.hcaptcha.com"],
    "img-src": ["'self' data: blob: ", "https://" + process.env.VUE_APP_STATIC_ASSETS_HOST, "https://s3.amazonaws.com/", "https://dfwa-prod-img.s3.amazonaws.com", "https://www.googletagmanager.com", "https://checkout.stripe.com", "https://*.s3.amazonaws.com", "https://*.us-east-1.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.us-east-1.amazonaws.com", "https://*.stripe.com", "https://cdn.sanity.io"],
    "style-src": ["'self'", "'unsafe-inline'", "https://" + process.env.VUE_APP_STATIC_ASSETS_HOST, "https://*.s3.amazonaws.com", "https://*.us-east-1.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.us-east-1.amazonaws.com", "https://cdn.quilljs.com", "https://cdn.jsdelivr.net", "https://api.mapbox.com", "https://hcaptcha.com", "https://*.hcaptcha.com", "sha256-0hAheEzaMe6uXIKV4EehS9pu1am1lj/KnnzrOYqckXk=", "https://fonts.googleapis.com"],
    "font-src": ["'self'", "https://fonts.gstatic.com", "https://js.stripe.com", "https://fonts.googleapis.com", "https://*.s3.amazonaws.com", "https://*.us-east-1.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.us-east-1.amazonaws.com", "https://" + process.env.VUE_APP_STATIC_ASSETS_HOST],
    "connect-src": [process.env.VUE_APP_API_URL, process.env.VUE_APP_CAP_URL, "https://api.stripe.com", "*"],
    "frame-src": ["'self'", "https://js.stripe.com", "https://hooks.stripe.com", "https://newassets.hcaptcha.com/", "https://www.hcaptcha.com/", "https://newassets.hcaptcha.com/", "https://hcaptcha.com", "https://*.hcaptcha.com"],
    "worker-src": ["'self' blob:"],
    "media-src": ["'self'", "https://" + process.env.VUE_APP_STATIC_ASSETS_HOST, "https://*.s3.amazonaws.com", "https://*.us-east-1.s3.amazonaws.com", "https://candm-prod-webshop-static-assets.s3.amazonaws.com", "https://candm-webshop-static-assets.s3.us-east-1.amazonaws.com"]
  }
};
function generateCSP(env) {
  var cspDirectives = cspConfig[env];
  var cspString = "";
  for (var directive in cspDirectives) {
    cspString += "".concat(directive, " ").concat(cspDirectives[directive].join(" "), "; ");
  }
  return cspString;
}
var currentEnv = process.env.NODE_ENV;
if (!process.env.VUE_APP_CSP_DISABLED) {
  var cspString = generateCSP(currentEnv);
  document.addEventListener("DOMContentLoaded", function (event) {
    document.querySelector("meta[http-equiv='Content-Security-Policy']").setAttribute("content", cspString);
  });
}

// Initialize mapbox map, Todo: singleton
// MapboxFactory.build();
new Vue({
  vuetify: vuetify,
  router: router,
  component: {
    paging: paging
  },
  render: function render(h) {
    return h(App);
  },
  mounted: function mounted() {
    AOS.init({
      offset: 80,
      // offset (in px) from the original trigger point
      delay: 0,
      // values from 0 to 3000, with step 50ms
      duration: 1200,
      // values from 0 to 3000, with step 50ms
      easing: "ease-out",
      // default easing for AOS animations
      once: true,
      // whether animation should happen only once - while scrolling down
      mirror: true,
      // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom" // defines which position of the element regarding to window should trigger the animation
    });
  }
}).$mount("#app");
var t = 1 + 2;
initStoredCurrencies();